module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "tab"
  }, _vm._l((_vm.tab), function(item, index) {
    return _c('span', {
      key: index,
      class: {
        'active': _vm.currTab === index
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.cTab(index)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currTab === 0),
      expression: "currTab === 0"
    }],
    staticClass: "goods-detail"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.goodsVideo),
      expression: "goodsVideo"
    }],
    staticClass: "video"
  }, [_c('video', {
    attrs: {
      "src": _vm.goodsVideo,
      "loop": "",
      "controls": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "default",
    domProps: {
      "innerHTML": _vm._s(_vm.goodsIntros)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currTab === 1),
      expression: "currTab === 1"
    }],
    staticClass: "comment"
  }, [_c('div', {
    staticClass: "grade"
  }, [_c('span', [_vm._v("宝贝与描述相符")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogin && _vm.commentFalg),
      expression: "isLogin && commentFalg"
    }],
    staticClass: "shoppl"
  }, [_c('a', {
    staticStyle: {
      "color": "#333"
    },
    attrs: {
      "name": "firstAnchor",
      "id": "firstAnchor",
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.jump()
      }
    }
  }, [_vm._v("我要评论")])])]), _vm._v(" "), (_vm.comment.total === 0) ? _c('div', {
    staticClass: "not-data"
  }, [_c('div', [_vm._v("暂无评论，抢沙发，赢取更多积分。")]), _vm._v(" "), _c('div', [_vm._v("共0条记录")])]) : _c('div', [_c('div', {
    staticClass: "list"
  }, [_c('ul', _vm._l((_vm.comment.list), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "pic"
    }, [_c('img', {
      attrs: {
        "src": item.face
      }
    }), _c('span', [_vm._v(_vm._s(_vm._f("filter_name")(item.uname)))]), _c('span', [_vm._v(_vm._s(item.levelname))])]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('div', [_vm._v(_vm._s(item.content))]), _vm._v(" "), _c('div', [_c('span', [_vm._v("评分："), (item.grade == '1') ? _c('b', {
      staticStyle: {
        "font-weight": "normal"
      }
    }, [_vm._v("差评")]) : _vm._e(), (item.grade == '2') ? _c('b', {
      staticStyle: {
        "font-weight": "normal"
      }
    }, [_vm._v("中评")]) : _vm._e(), (item.grade == '3') ? _c('b', {
      staticStyle: {
        "font-weight": "normal"
      }
    }, [_vm._v("好评")]) : _vm._e()]), _c('span', [_vm._v(_vm._s(_vm.unixToDate(item.dateline)))])]), _vm._v(" "), (item.videoPath) ? _c('div', {
      staticClass: "suolue"
    }, [_c('video', {
      staticClass: "fl",
      attrs: {
        "src": item.videoPath,
        "controls": "",
        "width": "150",
        "height": "150"
      }
    })]) : _vm._e(), _vm._v(" "), _c('viewer', {
      staticClass: "suolue",
      attrs: {
        "images": _vm.toArr(item.img)
      }
    }, _vm._l((_vm.toArr(item.img)), function(src, index) {
      return _c('img', {
        key: index,
        attrs: {
          "src": src,
          "width": "150",
          "height": "150"
        }
      })
    }), 0), _vm._v(" "), _c('viewer', {
      staticClass: "suolue",
      attrs: {
        "images": _vm.toArr(item.imagePath)
      }
    }, _vm._l((_vm.toArr(item.imagePath)), function(src, index) {
      return _c('img', {
        key: index,
        attrs: {
          "src": src,
          "width": "150",
          "height": "150"
        }
      })
    }), 0), _vm._v(" "), (item.reply !== null) ? _c('div', [_c('div', {
      staticClass: "top"
    }), _vm._v(" "), _c('div', {
      staticClass: "reply"
    }, [_c('h3', [_vm._v("开心云商客服：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.reply))])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clear"
    })], 1)])
  }), 0)]), _vm._v(" "), _c('paging', {
    attrs: {
      "getList": _vm.getCommentList,
      "total": _vm.comment.total,
      "pages": _vm.comment.pages,
      "no": _vm.page.no1
    },
    on: {
      "update:no": function($event) {
        return _vm.$set(_vm.page, "no1", $event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogin && _vm.commentFalg),
      expression: "isLogin && commentFalg"
    }],
    attrs: {
      "id": "discuss_form_wrapper"
    }
  }, [_c('form', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "action": "#",
      "method": "post",
      "id": "ivu-form"
    }
  }, [_c('div', {
    staticClass: "discuss_issue"
  }, [_c('div', {
    staticClass: "di_left"
  }, [_c('h2', [_c('b', [_vm._v("描述相符：")]), _vm._v(" "), _c('div', {
    staticClass: "grade"
  }, [_c('Rate', {
    model: {
      value: (_vm.desccredit),
      callback: function($$v) {
        _vm.desccredit = $$v
      },
      expression: "desccredit"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "value_wrapper"
  }, [_vm._v("\n                  您的评分：\n                  "), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "14px",
      "color": "#a90000"
    }
  }, [_vm._v(_vm._s(_vm.desccredit))]), _vm._v("分\n                ")])]), _vm._v(" "), _c('h2', [_c('b', [_vm._v("服务态度：")]), _vm._v(" "), _c('div', {
    staticClass: "grade"
  }, [_c('Rate', {
    model: {
      value: (_vm.servicecredit),
      callback: function($$v) {
        _vm.servicecredit = $$v
      },
      expression: "servicecredit"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "value_wrapper"
  }, [_vm._v("\n                  您的评分：\n                  "), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "14px",
      "color": "#a90000"
    }
  }, [_vm._v(_vm._s(_vm.servicecredit))]), _vm._v("分\n                ")])]), _vm._v(" "), _c('h2', [_c('b', [_vm._v("发货速度：")]), _vm._v(" "), _c('div', {
    staticClass: "grade"
  }, [_c('Rate', {
    model: {
      value: (_vm.deliverycredit),
      callback: function($$v) {
        _vm.deliverycredit = $$v
      },
      expression: "deliverycredit"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "value_wrapper"
  }, [_vm._v("\n                  您的评分：\n                  "), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "14px",
      "color": "#a90000"
    }
  }, [_vm._v(_vm._s(_vm.deliverycredit))]), _vm._v("分\n                ")])]), _vm._v(" "), _c('h2', [_c('b', [_vm._v("评分：")]), _vm._v(" "), _c('RadioGroup', {
    staticClass: "label",
    model: {
      value: (_vm.grade),
      callback: function($$v) {
        _vm.grade = $$v
      },
      expression: "grade"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "好评"
    }
  }), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "中评"
    }
  }), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "差评"
    }
  })], 1)], 1), _vm._v(" "), _c('h2', [_vm._v("为该商品评论")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }],
    staticClass: "ivu-input",
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "name": "content",
      "placeholder": "请在此处输入您的评论",
      "maxlength": "200"
    },
    domProps: {
      "value": (_vm.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value
      }
    }
  }), _vm._v(" "), _c('Upload', {
    ref: "upload",
    attrs: {
      "before-upload": _vm.handleBeforeUpload,
      "format": ['jpg', 'jpeg', 'png', 'gif'],
      "on-format-error": _vm.handleFormatError,
      "data": _vm.uploadData,
      "headers": {
        "Auth-Token": _vm.upHeaders
      },
      "on-exceeded-size": _vm.handleMaxSize,
      "on-success": _vm.handleSuccess,
      "on-error": _vm.handleError,
      "action": _vm.UploadUrl()
    }
  }, [_c('Button', {
    attrs: {
      "type": "ghost",
      "icon": "ios-cloud-upload-outline"
    }
  }, [_vm._v("选择文件")])], 1), _vm._v(" "), _c('p', [_vm._v("[文件小于5M，支持jpg、png、gif]")]), _vm._v(" "), _c('input', {
    staticClass: "regis_ent",
    attrs: {
      "type": "button",
      "value": "发表评论",
      "id": "discussBtn"
    },
    on: {
      "click": function($event) {
        return _vm.addComment('1')
      }
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currTab === 2),
      expression: "currTab === 2"
    }],
    staticClass: "guest-book"
  }, [(_vm.consult.total === 0) ? _c('div', {
    staticClass: "not-data"
  }, [_c('div', [_vm._v("暂无评论，抢沙发，赢取更多积分。")]), _vm._v(" "), _c('div', [_vm._v("共0条记录")])]) : _c('div', [_c('div', {
    staticClass: "list"
  }, [_c('ul', _vm._l((_vm.consult.list), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "pic"
    }, [(item.face) ? _c('img', {
      attrs: {
        "src": item.face
      }
    }) : _c('img', {
      attrs: {
        "src": "//static.kxymall.com/placeholder/no_picture.jpg"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.uname))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.levelname))])]), _vm._v(" "), _c('div', {
      staticClass: "problem_right"
    }, [_c('div', {
      staticClass: "problem_time"
    }, [_c('span', [_vm._v(_vm._s(_vm.chagneTime(item.replytime)))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.content))]), _vm._v(" "), (item.reply) ? _c('div', {
      staticClass: "problem_answer"
    }, [_c('div', {
      staticClass: "pa_top"
    }), _vm._v(" "), _c('div', {
      staticClass: "ps_bottom"
    }, [_c('h3', [_vm._v("开心云商客服：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.reply))])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clear"
    })])])
  }), 0)]), _vm._v(" "), _c('paging', {
    attrs: {
      "getList": _vm.getCommentList,
      "total": _vm.consult.total,
      "pages": _vm.consult.pages,
      "no": _vm.page.no3
    },
    on: {
      "update:no": function($event) {
        return _vm.$set(_vm.page, "no3", $event)
      }
    }
  })], 1), _vm._v(" "), (_vm.isLogin) ? _c('div', {
    staticClass: "ask_issue"
  }, [_c('div', [_c('h2', [_vm._v("请输入您的问题")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.askInfo),
      expression: "askInfo"
    }],
    staticClass: "shopzx",
    domProps: {
      "value": (_vm.askInfo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.askInfo = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ask_btn"
  }, [_c('a', {
    staticClass: "blue_btn",
    on: {
      "click": _vm.submitAsk
    }
  }, [_vm._v("提交咨询")])])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i'), _c('i'), _c('i'), _c('i'), _c('i')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e2d9087"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/goods-godule/module-detail-content.vue
// module id = 1525
// module chunks = 1